import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/medicationSlice";
import medicationApis from "src/api/medication";
import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get medication list saga
const GetMedicationListSaga = function* GetMedicationListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.getMedicationList,
      payload
    );
    yield put(actions.getMedicationListSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getMedicationListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get medication by id saga

const GetMedicationByIdSaga = function* GetMedicationByIdSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.getMedicationById,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getMedicationByIdSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getMedicationByIdError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// set medication reminder saga
const AddMedicationSaga = function* AddMedicationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.addMedication,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.addMedicationSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.addMedicationError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// edit medication saga
const EditMedicationSaga = function* EditMedicationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.editMedication,
      payload
    );
    yield put(actions.editMedicationSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.editMedicationError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// delete medication saga
const DeleteMedicationSaga = function* DeleteMedicationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.deleteMedication,
      payload
    );
    yield put(actions.deleteMedicationSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.deleteMedicationError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// medication log saga
const GetMedicationLogSaga = function* GetMedicationLogSaga({
  payload: { resolve, reject, queryParams },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      medicationApis.getMedicationLog,
      queryParams
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getMedicationLogSuccess(response?.data));
    resolve(response);
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error occurred";
    yield put(actions.getMedicationLogError(errorMessage));
    reject(error);
  }
};

export default function* medicationSaga() {
  yield all([
    takeEvery(actions.getMedicationListRequest, GetMedicationListSaga),
    takeEvery(actions.getMedicationByIdRequest, GetMedicationByIdSaga),
    takeEvery(actions.addMedicationRequest, AddMedicationSaga),
    takeEvery(actions.editMedicationRequest, EditMedicationSaga),
    takeEvery(actions.deleteMedicationRequest, DeleteMedicationSaga),
    takeEvery(actions.getMedicationLogRequest, GetMedicationLogSaga),
  ]);
}
